// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const drawingHistoryStyle = theme => ({

	// coverArea: {
	// 	marginTop: theme.spacing(1)
	// },

	// coverPaper: {
	// 	minHeight: theme.spacing(10),
	// 	padding: theme.spacing(1)
	// },

	// coverContent: {
	// 	display: "flex",
	// 	alignItems: "center",
	// },

	// drawingArea: {
	// 	marginTop: theme.spacing(1),
	// 	marginBottom: theme.spacing(1),
	// 	marginLeft: theme.spacing(2),
	// 	marginRight: theme.spacing(2)
	// },


	// drawingCategoryArea: {
	// 	marginTop: theme.spacing(1),
	// 	marginBottom: theme.spacing(1),
	// 	marginLeft: theme.spacing(2),
	// 	marginRight: theme.spacing(2)
	// },

	// drawingType: {
	// 	display: "flex",
	// 	alignItems: "center",
	// },

	// ToggleButtonGroup: {
	// 	width: "100%"
	// },

	// ToggleButton: {
	// 	width: "25%",

	// },


	webviewer: {
		// height: window.outerHeight - (window.outerHeight - window.innerHeight + 30)
		
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 300)
	},


	// drawingTable: {
	// 	paddingTop: theme.spacing(2),
	// 	PaddingBottom: theme.spacing(2),
	// },







})


export default drawingHistoryStyle